
import ConsentBar from './components/cookie-consent'

let app = new Vue({
    el: '#cookie-consent-app',
    components: {
        'alf-consent-bar': ConsentBar,
    }
})


// WEBPACK FOOTER //
// ./resources/assets/js/site/app-cookie-consent.js